import { render, staticRenderFns } from "./PayNotification.vue?vue&type=template&id=67f85775&scoped=true&lang=pug&"
import script from "./PayNotification.vue?vue&type=script&lang=js&"
export * from "./PayNotification.vue?vue&type=script&lang=js&"
import style0 from "./PayNotification.vue?vue&type=style&index=0&id=67f85775&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f85775",
  null
  
)

export default component.exports